import { selectionTypes } from './content';
import _ from 'lodash';
import { toRoman } from './utils';

const validName = (market) => {
  switch (market.marketTypeId) {
    case 4:
      return 'exacta';
    case 6:
      return 'trifecta';
    case 7:
      return 'superfecta';
    default:
      return market.name;
  }
};

const checkIfCrossEvent = (market) => {
  return market.isCrossEventMarket || (market.crossEvents && market.crossEvents.length > 0);
};

const getNumbersToPredictCount = (market) => {
  const marketName = validName(market);
  let numbersToPredictCount =market.isCrossEventMarket ? market.crossEvents.length : selectionTypes['singlePerm'][marketName]?.positions;
  let inOrder = true;

  if (!numbersToPredictCount){
    const selection = selectionTypes[marketName];
    numbersToPredictCount = selection?.numbersToPredictCount || market.predictionCount;
    inOrder = selection?.inOrder || market.inOrder || inOrder;
  }

  return { numbersToPredictCount, inOrder };
};

const combinationsValues = (orderedPositions, selectionType, market, horsePosition) => {
  let rankedNumbers = [];
  let anyNumbers = [];
  let inOrder = true;
  const marketName = validName(market);
  let numbersToPredictCount =market.isCrossEventMarket ? market.crossEvents.length : selectionTypes['singlePerm'][marketName]?.positions;

  if (!numbersToPredictCount){
    const selection = selectionTypes[marketName];
    numbersToPredictCount = selection?.numbersToPredictCount || market.predictionCount;
    inOrder = selection?.inOrder || market.inOrder || inOrder;
  }

  if (selectionType === 'singlePerm' || selectionType === 'Single/Perm' || market.isCrossEventMarket){
    // Here we need to save the selections into ranked numbers and if they are not ranked numbers we should save them in any numbers this might change since nobody is really sure how this works
    rankedNumbers = _.map(orderedPositions, (positions, key) => {
      return ({ numbers: _.compact(_.map(positions, (competitor) => {
        if (!isNaN(key) || market.isCrossEventMarket){
          return competitor;
        } else {
          anyNumbers.push(competitor);
          return null;
        }
      })) });
    });
  } else if (selectionType === 'floating' || selectionType === 'Floating'){
    // If we have bankers selected we should save as rankedNumbers times the number of positions, this might also change in the future
    let i = 0;
    const bankers = horsePosition[0];
    anyNumbers = horsePosition[1];
    while (i < numbersToPredictCount){
      rankedNumbers.push({ numbers: bankers });
      i+=1;
    }
  } else {
    // If the type of stake is boxed or not a special market we want to save the selections that we have in anyNumbers
    anyNumbers = horsePosition[0];

    if (_.isEmpty(anyNumbers)){
      const lastIndex = horsePosition.length -1;
      anyNumbers = horsePosition[lastIndex];
      inOrder = false;
    }
  }

  const payload = {
    anyNumbers: _.compact(anyNumbers),
    rankedNumbers,
    inOrder,
    numbersToPredictCount,
    ...(market.isCrossEventMarket && { type:'cross_event' })
  };
  return payload;
};


const allGrayedOut = (selectedHorsePosition, selectionType = 'singlePerm') => {
  // This will be used to gray out the all column in multiple compontents like header, checkboxes and summary
  const positionsSelected  =[];
  const selectedHores = [];
  // eslint-disable-next-line no-unused-vars
  const numberOfPositions = selectedHorsePosition.length -1;


  if (selectionType === 'floating' && selectedHorsePosition[0]?.length >= numberOfPositions) return true;
  for (let i = numberOfPositions -1; i >=0; i-=1){
    if (selectedHorsePosition[i]?.length > 0){
      positionsSelected.push(i);
      selectedHores.push(...selectedHorsePosition[i]);
    }
  }
  if (_.uniq(positionsSelected).length >= numberOfPositions &&
  _.uniq(selectedHores).length >= numberOfPositions &&
  selectionType === 'singlePerm') return true;

  return false;
};

const orderPosition = (selectedSelectionType, selectedMarket, selectedHorsePosition) => {
  const hash ={};

  let selectionType = selectedSelectionType !== 'singlePerm' ?
    selectionTypes[selectedSelectionType] :
    selectionTypes[selectedSelectionType][validName(selectedMarket)];

  if (selectedMarket && !selectedMarket.isCrossEventMarket){

    if (!selectionType) selectionType = selectionTypes[validName(selectedMarket)];
    let i =selectionType?.positions;
    if (selectedSelectionType ==='singlePerm'){
      while (i>0){
        hash[i] = selectedHorsePosition[i -1];
        i-=1;
      }
    }
    if (selectedSelectionType=== 'floating'){
      hash['bankers'] = selectedHorsePosition[0];
    }
    if (!allGrayedOut(selectedHorsePosition, selectedSelectionType)){
      let all = selectionType?.positions;
      if (selectedSelectionType === 'floating'){
        all = 1;
      } else if (selectedSelectionType === 'boxed' || !selectedSelectionType){
        all = 0;
      }
      hash['all'] = selectedHorsePosition[all];
    }
  } else {
    for (const leg in selectedMarket?.crossEvents){
      const position = `Leg ${ toRoman(+leg +1) }`;
      hash[position] = selectedHorsePosition[leg];
    }
  }

  return hash;
};

export { combinationsValues, validName, orderPosition, allGrayedOut, checkIfCrossEvent, getNumbersToPredictCount };
